module.exports = __webpack_public_path__ + "static/We_d_love_to_help_with_your_product._2x-4ac371682bbe34114a652ae37fec8c5e.png";